import { useEffect, useMemo, useState } from 'react';
import { useQuery } from '@apollo/client/react';

import { ExtraUserFieldsDocument } from 'graphql/types';
import { ISearchProps, TFilterBarItem } from 'common/types';
import { TQueryParams } from 'common/utils/getSearchUrl';
import {
    getExtraFieldsQueryParams,
    getSelectedExtraFieldsFilters,
} from 'common/utils/extraFields';
import { useApolloError } from 'common/hooks/useApolloError';

import { getExtraUserFieldsFilters } from './extraUserFieldsFilters';

export const useUserSearch = (): ISearchProps => {
    const { showApolloError } = useApolloError();
    const [searchQueryParam, setSearchQueryParam] = useState('');
    const [queryParams, setQueryParams] = useState<TQueryParams>({});

    const {
        data: extraUserFieldsData,
        loading,
        error,
    } = useQuery(ExtraUserFieldsDocument);

    useEffect(() => {
        if (error) {
            showApolloError(error);
        }
    }, [error, showApolloError]);

    // Build a list of filters
    const filters = useMemo(
        () =>
            getExtraUserFieldsFilters(
                extraUserFieldsData?.extraUserFields || []
            ),
        [extraUserFieldsData]
    );

    const selectedFilters = getSelectedExtraFieldsFilters(queryParams, filters);

    const handleSearch = (searchValue: string) => {
        setSearchQueryParam(searchValue);
    };

    const handleFilterSelect = (selected: TFilterBarItem[]) => {
        const queryParams = getExtraFieldsQueryParams(selected);

        setQueryParams(queryParams);
    };

    return {
        filters,
        searchQueryParam: searchQueryParam || '',
        selectedFilters,
        filtersLoading: loading,
        handleSearch,
        handleFilterSelect,
    };
};
